// @flow

import React from 'react';
import {Callout} from 'docs/components';
import type {ConditionGroupXRayData} from 'docs/data';

type InvalidRequirementsProps = {
  conditions: ConditionGroupXRayData,
};

export const InvalidRequirementsBanner = ({
  conditions,
}: InvalidRequirementsProps) => {
  const all = [
    ...conditions.affirmative,
    ...conditions.negative,
    ...conditions.inline,
  ];
  const invalid = all.filter((condition) => !condition.valid);
  if (invalid.length) {
    return (
      <Callout type="warning">
        <p>This page specifies invalid conditions in its front matter:</p>
        <br />
        <ul>
          {invalid.map((condition) => (
            <li key={condition.name}>
              <b>Invalid {condition.type}:</b> {condition.name}
            </li>
          ))}
        </ul>
      </Callout>
    );
  }

  return null;
};

type RequirementsBannerProps = {
  conditions: ConditionGroupXRayData,
  internal: boolean,
  allowed: boolean,
};

export const RequirementsBanner = ({
  conditions,
  internal,
  allowed,
}: RequirementsBannerProps) => {
  const affirmative = conditions.affirmative || [];
  const negative = conditions.negative || [];

  const list = [
    ...affirmative.map((condition) => {
      return (
        <li key={condition.name}>
          <b>Requires {condition.type}:</b> <code>{condition.name}</code>
        </li>
      );
    }),
    ...negative.map((condition) => {
      return (
        <li key={condition.name}>
          <b>Requires {condition.type}:</b> <i>NOT</i>{' '}
          <code>{condition.name}</code>
        </li>
      );
    }),
  ];

  if (list.length < 1) {
    return (
      <Callout type="warning">
        <p>
          Loading this page doesn't require a flag or gate, meaning that it's
          visible to the entire internet.
        </p>
      </Callout>
    );
  }

  return (
    <Callout type="note">
      <p>
        This page is protected and can only be viewed under specific conditions.
      </p>
      <br />
      <ul>{list}</ul>
      {/* TODO(adreyfus) Bring back callout:
        {allowed ? (
        <p>
          Your current account meets those requirements and would be able to see
          the doc in production.
        </p>
      ) : (
        <p>
          Your current account <b>does not meet</b> the requirements and would
          see a 404 in production.
        </p>
      )}
      */}
    </Callout>
  );
};
